<template>
  <v-row>
    <v-col cols="12">
      <h2>{{ $t("commission_member.head") }}</h2>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title> {{ $t("commission_member.head_list") }} </v-card-title>
        <v-card-actions class="pb-0 d-flex align-start">
          <v-row no-gutters>
            <span>
              <date-picker-input ref="startDate" :date="dateFrom" :label="$t('commission_member.date_from')"
                @setValue="dateFrom = $event" />
            </span>
            <span>
              <date-picker-input ref="endDate" :date="dateTo" :label="$t('commission_member.date_to')"
                @setValue="dateTo = $event" />
            </span>
            <span class="mr-2" style="display: flex;">
              <div
                style="width: 98px; height: 38px; text-agent: center; background: #e5e5e5; border-radius: 8px; color: #737076; display: flex; justify-content: center; align-items: center;">
                {{ $t('commission_member.type') }} </div>
              <v-select :items="roles" item-text="name" v-model="valType" item-value="id" outlined dense style="max-width: 110px;" />
            </span>
            <v-btn color="primary" @click="searchTurnBonus" class=""> {{ $t('search') }} </v-btn>
          </v-row>
          <!-- <v-btn color="primary" class="px-5"> ค้นหา </v-btn> -->
        </v-card-actions>
        <v-card-title>
          {{ $t('commission_member.summary_bonus') }} : &nbsp;<span style="color: #28c76f !important">{{ total | currency
          }}</span></v-card-title>
        <v-card-actions>
          <v-spacer />
          <span class="px-3 mt-5">{{ $t('search') }}:</span>
          <div style="width: 150px" class="mt-5">
            <v-text-field v-debounce:500ms="searchKeyword" :date="searchData" outlined dense hide-details />
          </div>
        </v-card-actions>
        <v-card-actions class="pt-0">
          <v-data-table mobile-breakpoint="0" style="width: 100%" :headers="headers" :no-data-text="$t('not_found')"
            :no-results-text="$t('not_found')" :options.sync="pagination" :server-items-length="pagination.totalItems"
            :items-per-page="pagination.rowsPerPage" :loading="loading" :page.sync="pagination.currentPage" :footer-props="{
              'items-per-page-options': [10, 25, 30, 40, 50],
            }" :items="members">
            <template v-slot:[`item.amount`]="{ item }">
              {{ item.amount | currency }}
            </template>
          </v-data-table>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import DatePickerInput from '@/components/input/DatePickerInput.vue'
import SelectInput from '@/components/input/SelectInput.vue'
import store from '@/store'
export default {
  components: {
    DatePickerInput,
    SelectInput,
  },

  data() {
    return {
      dateFrom: moment().subtract(3, 'days').format('YY-MM-DD'),
      dateTo: moment().format('YY-MM-DD'),
      date: null,
      searchData: "",
      headers: [
        {
          text: this.$t('commission_member.header1'),
          value: 'phone',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('commission_member.header2'),
          value: 'name',
          width: '100px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('commission_member.header3'),
          value: 'type',
          width: '95px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('commission_member.header4'),
          value: 'amount',
          width: '95px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('commission_member.header5'),
          value: 'commission_percent',
          width: '95px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('commission_member.header6'),
          value: 'commission_receive',
          width: '95px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('commission_member.header10'),
          value: 'game_type',
          width: '95px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('commission_member.header7'),
          value: 'time_received',
          width: '95px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('commission_member.header8'),
          value: 'time_out',
          width: '95px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('commission_member.header9'),
          value: 'date',
          width: '95px',
          align: 'center',
          sortable: false,
        },

      ],
      members: [],
      loading: false,
      valType: "all",
      roles: [{id:"all",name:"all"}, {id:"deposit",name:"deposit"}, {id:"game",name:"game"}],
      pagination: {
        currentPage: 1,
        rowsPerPage: 25,
        totalItems: 0,
      },
      total: 0,
    }
  },
  async created() {
    this.addLogPage()
  },
  watch: {
    pagination: {
      async handler(newValue, oldValue) {
        let cont = false
        if (oldValue.page !== newValue.page) cont = true
        if (oldValue.itemsPerPage !== newValue.itemsPerPage) cont = true
        if (oldValue.sortBy !== newValue.sortBy) cont = true
        if (oldValue.sortDesc !== newValue.sortDesc) cont = true
        if(cont)await this.getTurnBonus(newValue.page, newValue.itemsPerPage, this.$refs.startDate.value, this.$refs.endDate.value, this.searchData)
      },
      deep: true,
    },
  },
  methods: {
    async addLogPage() {
      try {
        let data
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(res =>
          data = {
            ip: res.data.ip,
            name: 'โบนัสคอมมิชชั่น',
            url: window.location.href,
            detail: 'รายการโบนัสคอมมิชชั่น',
            admin: userSystem.name ? userSystem.name : '',
          }
        )
        await this.$store.dispatch('addLogPage', data)
      } catch (e) {
        // if (!e.message.includes('Unexpected token') || !e?.includes('Unexpected token') || !e.message.includes('Unexpected identifier')) {
        //   this.$swal.fire({
        //     icon: 'error',
        //     title: e.message,
        //   })
        // }
      }
    },
    async searchTurnBonus() {
      await this.getTurnBonus(1, this.pagination.rowsPerPage, this.$refs.startDate.value, this.$refs.endDate.value, this.searchData)
      this.pagination.currentPage = 1
    },
    async getTurnBonus(page, row, time_from, time_to, phone) {
      this.loading = true
      this.members = []

      let rs = await this.$store.dispatch('getCommissionMemberHistoryReport', {
        page: page,
        rows: row,
        time_from:this.formatDateYYYY(time_from),
        time_to: this.formatDateYYYY(time_to) ,
        type: this.valType,
        search:phone
      })
      this.pagination.totalItems = parseInt(rs.count);
      this.total=(rs.receive)?rs.receive:0;
      rs.data.forEach(element => {
        let type = (element.deposit_id)?"deposit":"turnover";

        this.members.push({
          id: element.id,
          phone:element.phone,
          name: element.name,
          type:type,
          amount: element.amount,
          commission_percent: element.commission_percent,
          commission_receive: element.commission_receive,
          game_type:element.game_type,
          time_received: (element.time_received)?element.time_received.replace('T', ' ').slice(0, 19):"",
          time_out: (element.time_out)?element.time_out.replace('T', ' ').slice(0, 19):"",
          date: element.created_at ? moment(element.created_at).format('YY-MM-DD HH:mm') : '',
        })
      })
      this.loading = false
    },
    async searchKeyword(value) {
      this.searchData = value
      await this.getTurnBonus(1, this.pagination.itemsPerPage, this.$refs.startDate.value, this.$refs.endDate.value, value)
      this.pagination.currentPage = 1
    },
    formatDateYYYY(date) {
      const dateConv = date?.length > 8 ? date.substring(2) : date
      return moment(`20${dateConv}`).format('YYYY-MM-DD')
    },
  },
}
</script>
